var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGradiant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 894,
    height: 657,
    viewBox: "0 0 894 657",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.24502e-06 31.3293L1.11233e-07 626C4.98009e-08 643.121 13.8792 657 31 657L863 657C880.121 657 894 643.121 894 626L894 294.703C894 281.186 885.242 269.228 872.356 265.148L40.3556 1.77478C20.3713 -4.55139 2.32023e-06 10.3676 2.24502e-06 31.3293Z",
    fill: "url(#paint0_linear_6808_6303)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6808_6303",
    x1: 0.00000119845,
    y1: 323,
    x2: 894,
    y2: 323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D61C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4CAFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradiant);
export default __webpack_public_path__ + "static/media/gradiant.be0544baeb551cbf31a0a4a8e2238326.svg";
export { ForwardRef as ReactComponent };